import Vue from 'vue'
import Vuex from 'vuex'
import modulePaths from '@moeinmdn/mixitweb-front-modules/src/plugin/store'
import DashboardResource from "@/store/DashboardResource";

Vue.use(Vuex)


export default new Vuex.Store({
    modules: {
        DashboardResource,
        ...modulePaths,
    }
})